import React from 'react';

import { useSearchResults } from '@context/DataContext';
import { getValue } from '@hooks/useLocalStorage';
import formatSearchResults from './formatSearchResults';

// events
import composeCardEvents from './composeCardEvents';
import CardEvents from '@molecules/Cards/CardEvents';

// peer support
import composeCardPeer from './composeCardPeer';
import CardPeer from '@molecules/Cards/CardPeer';

const SearchResultCardList = ({ itemDefs }) => {
  const { results, resultsSummary: summary, resultTab, localStorageKey, moduleType, tabNames } = useSearchResults();

  const getListMarkup = () => {
    let items,
      className = null;
    let Card = <></>;

    switch (moduleType) {
      // event cards
      case 'event':
        Card = CardEvents;
        className = 'event-cards__list sqz-card-elevate sqz-grid sqz-grid--3-col';

        if (resultTab === tabNames.all) {
          const rawItems = formatSearchResults(results, itemDefs);
          items = composeCardEvents(rawItems);
        }
        break;

      // peer support cards
      case 'peer-support':
        Card = CardPeer;
        className = 'peer-cards__list sqz-card-elevate sqz-grid sqz-grid--1-col';
        if (resultTab === tabNames.all) {
          const rawItems = formatSearchResults(results, itemDefs);
          items = composeCardPeer(rawItems);
        }
        break;

      default:
        break;
    }

    // viewing saved items
    if (tabNames.saved === resultTab) items = getValue(localStorageKey);

    return items?.length ? (
      <>
        <ul start={summary.currStart} className={className}>
          {items.map((data) => (
            <Card data={data} key={`card-${data?.id}`} />
          ))}
        </ul>
      </>
    ) : null;
  };

  return getListMarkup();
};

export default SearchResultCardList;
